/**
 * Validación del destino que se retoma después del login. Sale de la URL pedida sin sesión, así que
 * es entrada del usuario: `//otro-sitio` es una URL relativa al protocolo y navegar a ella sale del
 * dominio; React Router 6 no lo bloquea (GHSA-wrjc-x8rr-h8h6), el filtro va aquí.
 */

/** Rechaza cualquier cosa que no sea una ruta interna con una sola barra inicial. */
export function destinoSeguro(destino: string | null): string | null {
  if (!destino) return null;
  if (!destino.startsWith('/')) return null;
  // `//host` y `/\host` son relativas al protocolo: el navegador saldría del dominio.
  if (destino.startsWith('//') || destino.startsWith('/\\')) return null;
  // Controles y espacios: el navegador puede normalizarlos distinto que este filtro. Se comparan
  // por punto de código porque dentro de una expresión regular quedarían invisibles al revisar.
  for (const caracter of destino) {
    const punto = caracter.codePointAt(0)!;
    if (punto <= 0x20 || punto === 0x7f) return null;
  }
  if (/\s/.test(destino)) return null;
  if (destino === '/') return null;
  return destino;
}
